


















import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ModalConfirm from '@/components/Form/ModalConfirm.vue';

export default Vue.extend({
    name: 'LogoutForm',
    components: {
        ModalConfirm,
    },
    computed: {
        ...mapGetters('auth', {
            userLogin: 'getUserLogin',
        }),
    },
    methods: {
        ...mapActions('auth', {
            logoutAction: 'logout'
        }),
        logout() {
            this.logoutAction().then(res => {
                if (res === true) {
                    this.$router.push('/auth');
                } else {
                    console.log('logout error');
                }
            });
        },
    },
    data() {
        return {
            logoutModal: false,
        }
    },
});
